<template>
    <main-layout>
        <app-header></app-header>
        <nav class="nav-home wrap">
            <a id="btn-offline" class="btn sync sml" v-if="actions.length > 0" @click.prevent="trySync('synchro')">
                <i class="actions">{{ actions.length }}</i>
                <span>
                  <strong>Actions</strong>
                  Non synchronisées
                </span>
                <i class="fas fa-sync"></i>
            </a>

            <a id="btn-sync" class="btn sync sml" v-if="actions.length <= 0" @click.prevent="trySync('init')">
                <span>
                  <strong>Synchroniser</strong>
                  Les données
                </span>
                <i class="fas fa-sync"></i>
            </a>

            <span class="if" v-if="type === 'technicien'">

                <router-link id="btn-interventions" class="btn sync" to="liste-fibsdd">
                    <i class="icon-tools"></i>

                    <i class="actions" v-if="this.numberFibsdd() > 0" style="z-index: 1;">{{ this.numberFibsdd() }}</i>
                    <span>
                      <strong style="z-index: 1;">Intervention{{ this.numberFibsdd() > 1 ? 's' : '' }}</strong>
                    </span>
                    <i class="icon-go"></i>
                </router-link>

                <div>
                    <router-link id="btn-contrat" class="btn" to="contrat-assemblage">
                        <i class="icon-contract"></i>
                        <span>
                            Contrat<br>
                            <strong>d'assemblage</strong>
                        </span>
                    </router-link>

                    <router-link id="btn-interventions-d" class="btn" to="ctrl-multi">
                        <i class="icon-tools"></i>
                        <span>
                            <strong>Controles d'étanchéité</strong>
                            périodiques  - multiples
                        </span>
                    </router-link>
                </div>

            </span>

            <router-link id="btn-detenteurs" class="btn" :class="{ sml: type !== 'technicien' }" to="liste-detenteurs">
                <i class="icon-factory"></i>
                <span>
                  <strong>Détenteurs</strong>
                  &amp; installations
                </span>
                <i class="icon-go"></i>
            </router-link>

            <div>
                <router-link id="btn-bouteilles" class="btn sml" to="liste-bouteilles">
                    <i class="icon-gas"></i>
                    <span>Bouteilles</span>
                </router-link>

                <router-link v-if="type === 'technicien'" class="btn sml" id="btn-outils" to="liste-outils">
                    <i class="icon-tool"></i>
                    <span>Outillage</span>
                </router-link>
            </div>

            <a class="btn tutobtn" target="_blank" v-show="token" :href="`https://admin.fi360.fr/tutorials?token=${token}`">
                <span>
                    <strong>TUTORIELS</strong>
                    F.i360°
                </span>
                <i class="icon-go"></i>
            </a>

            <div>
                <button id="btn-support" style="display: none;" @click="openSupport">
                    Support
                    <div class="indicator" v-if="badgeCount > 0">
                        <div class="noti_count" role="status">{{ badgeCount }}</div>
                    </div>
                </button>
            </div>

        </nav>

    </main-layout>
</template>

<script>

    import Offline from '../../js/models/Offline'
    import User from '../../js/models/User'
    import History from "../../js/core/History";

    export default {

        data() {
            return {
                actions: [],
                type: null,
                token: null,
                inters: 0
            }
        },
        computed: {
            badgeCount() {
                return this.$root.badgeCount;
            }
        },

        methods: {

            numberFibsdd(){
                localforage.getItem('listFibsdd').then(fi => {
                    fi = JSON.parse(fi);
                    if (Array.isArray(fi)) {
                        this.inters = fi.filter(f => f.cloture === false).length;
                    }
                }).catch();
                return this.inters;
            },
            checkSignature(){
                User
                    .getUserData(usr => {
                        if(!usr.signature64){
                            this.$router.push('configuration')
                        }
                    })
            },

            lock(e) {
                e.preventDefault();
                swal('Indisponible', 'Cette fonctionnalité sera disponible prochainement', 'error')
            },

            async openSupport() {
                const profil = JSON.parse(await localforage.getItem("profil"));
                if (!profil || !profil.operator) return;
                let id = profil.uid;
                let token = profil.operator.token;

                var url = "https://support.fi360.fr/public/list?token=" + encodeURIComponent(token) + "&user=" + id;

                document.getElementById('supportObject').setAttribute('data', url);

                document.querySelector("dialog").showModal();
            },

            fetchOfflineActions() {
                Offline
                    .getList()
                    .then(data => {
                        this.actions = data
                    })
                    .catch()
            },

            trySync(type) {
                if (!navigator.onLine) {
                    swal('Pas de connexion internet',  'Veuillez vous connecter à internet pour pouvoir vous synchroniser avec le serveur.', 'error')
                } else {

                    //return console.log('here');

                    let router = this.$router;

                    if(type === 'synchro'){
                        swal({
                            title: 'Envoi des données',
                            text: "Êtes-vous sûr de vouloir envoyer vos données au serveur ? Assurez vous d'avoir une bonne connexion réseau.",
                            type: 'question',
                            showCancelButton: true,
                            cancelButtonText: 'Non',
                            confirmButtonText: 'Oui'
                        }).then(
                            () => {

                                return router.push({name: type})
                            },
                            () => { swal.close() }
                        )
                    } else {
                        return router.push({name: type})
                    }
                }

            }

        },

        mounted() {
            localforage.getItem('api-token').then(token => this.token = token).catch();
            this.fetchOfflineActions();
            this.checkSignature();
            User.getUserData(data => this.type = data.type)


            /** Start Support */
            let btnSupport = document.getElementById("btn-support");

            localforage.getItem('profil').then(user => {
                user = JSON.parse(user);
                if (!user || !user.operator) return;
                if(user.operator.token !== null){
                    btnSupport.style.display = 'block';
                }
            }).catch(() => {});

            /** End Support */

            History.initialisation();


        }
    }

</script>

<style scoped>
    .tutobtn {
        background-color: #999;
    }

.indicator {
  position: absolute;
  top: -10px; /* Adjusted for better vertical positioning */
  right: -10px; /* Adjusted for better horizontal positioning */
  width: 24px;
  height: 24px;
  background-color: red;
  border: 3px solid white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.noti_count {
  font-family: 'Montserrat', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  color: aliceblue;
  font-weight: 700;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// Home.vue?3520226c